import { render, staticRenderFns } from "./GeneralTest.vue?vue&type=template&id=76c80c9c&"
import script from "./GeneralTest.vue?vue&type=script&lang=js&"
export * from "./GeneralTest.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GeneralTest.vue"
export default component.exports